var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HeaderView'),_c('router-view'),_c('FooterView',{attrs:{"hideLinks":_vm.hideFooterLinks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }